var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"background":_vm.background,"layout":_vm.layout,"page-size":_vm.pageSize,"current-page":_vm.currentPage,"total":_vm.total,"hide-on-single-page":""},on:{"current-change":_vm.currentChange,"size-change":_vm.sizeChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }